// Geografía pre-procesada para el mapa en vivo.
// Convertimos el topojson de países (world-atlas) a GeoJSON una sola vez y
// armamos una proyección fija centrada en Argentina + Uruguay. Bundleamos el
// archivo localmente para no depender de la red en la TV.
import { feature } from 'topojson-client'
import { geoMercator } from 'd3-geo'
import topo from './geo/countries-50m.json'

// Todos los países (contexto: Chile, Brasil, Paraguay, etc. se ven tenues)
export const WORLD = feature(topo, topo.objects.countries)

// IDs ISO numéricos: Argentina = 032, Uruguay = 858
export const HIGHLIGHT_IDS = ['032', '858']

const HIGHLIGHT = {
  type: 'FeatureCollection',
  features: WORLD.features.filter(f => HIGHLIGHT_IDS.includes(f.id))
}

// viewBox del SVG. La región es más alta que ancha (Argentina llega al sur),
// así que usamos un lienzo en formato retrato y dejamos que el SVG escale.
export const MAP_WIDTH = 760
export const MAP_HEIGHT = 1040

// Proyección Mercator ajustada para que AR + UY entren con un margen.
export const projection = geoMercator().fitExtent(
  [[60, 50], [MAP_WIDTH - 60, MAP_HEIGHT - 50]],
  HIGHLIGHT
)
